import React from 'react'
import { css, StyleSheet } from 'aphrodite'
import Tooltip from '@material-ui/core/Tooltip'
import { AppTheme } from '../../../../styles/AppTheme'
import { chatbotNodeIcon } from './ChatbotNodeHeader'
import { NODE_PALETTE } from './chatbotGraph'

export function ChatbotNodePalette(props) {
  const onAddType = props.onAddType
  const saveDisabled = !!props.saveDisabled
  return (
    <div className={css(Styles.bar)}>
      <div className={css(Styles.hint)}>Add a Step to the Chatbot</div>
      <div className={css(Styles.row)}>
        <div className={css(Styles.chips)}>
          {(props.palette || NODE_PALETTE || []).map(item => (
            <button
              key={item.type}
              type='button'
              className={css(Styles.chip)}
              onClick={() => onAddType && onAddType(item.type)}
            >
              <i className={'material-icons-outlined ' + css(Styles.chipIcon)}>{chatbotNodeIcon(item.type)}</i>
              {item.label}
            </button>
          ))}
        </div>
        <Tooltip title={props.saveTooltip || 'Save'} arrow>
          <span className={css(Styles.saveWrap)}>
            <button
              type='button'
              className={css(Styles.saveBtn, saveDisabled && Styles.saveBtnDisabled)}
              disabled={saveDisabled}
              onClick={saveDisabled ? undefined : props.onSave}
            >
              <i className={'material-icons-outlined ' + css(Styles.saveIcon)}>save</i>
              Save
            </button>
          </span>
        </Tooltip>
      </div>
    </div>
  )
}

const Styles = StyleSheet.create({
  bar: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
    padding: '8px 12px',
    boxSizing: 'border-box',
    borderBottom: '1px solid ' + AppTheme.borderColor,
  },
  hint: {
    fontSize: 13,
    fontWeight: 600,
    color: '#222222',
    lineHeight: '18px',
    flexShrink: 0,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    flex: 1,
    minWidth: 0,
  },
  chips: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
    minWidth: 0,
    flex: 1,
  },
  chip: {
    minWidth: 96,
    height: 32,
    padding: '0 14px',
    borderRadius: 8,
    border: '1px solid ' + AppTheme.borderColor,
    backgroundColor: AppTheme.secondaryBg,
    color: '#222222',
    fontSize: 13,
    fontWeight: 600,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 6,
    ':hover': {
      borderColor: AppTheme.primaryColor,
    },
  },
  chipIcon: {
    fontSize: 18,
    color: '#6B7280',
  },
  saveWrap: {
    flexShrink: 0,
  },
  saveBtn: {
    height: 32,
    padding: '0 14px',
    borderRadius: 8,
    border: '1px solid ' + AppTheme.primaryColor,
    backgroundColor: AppTheme.primaryColor,
    color: '#ffffff',
    fontSize: 13,
    fontWeight: 600,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 6,
  },
  saveBtnDisabled: {
    borderColor: AppTheme.borderColor,
    backgroundColor: AppTheme.secondaryBg,
    color: '#AAAAAA',
    cursor: 'not-allowed',
  },
  saveIcon: {
    fontSize: 18,
  },
})
